export const COMMENTS_BASE_QUERY_KEY = "comments";
const COMMENTS_LIST_QUERY_KEY = "list";

export const getCommentsListKey = ({
  postId,
  parentCommentId,
  usedIn = null,
}: {
  postId?: number;
  parentCommentId?: number | null;
  usedIn?: string | null;
}) =>
  [
    COMMENTS_BASE_QUERY_KEY,
    postId,
    COMMENTS_LIST_QUERY_KEY,
    parentCommentId,
    usedIn,
  ].filter(Boolean);
